import React, { useEffect } from 'react';
import SubscriptionStatusComponent from './SubscriptionStatusComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import { getModel } from './selectors';
import * as actions from './actions';
import { withErrorBoundaryTrigger } from 'sharedComponents/ErrorBoundary';

import './style.scss';
import { setSelectedNotification } from '../../PowertrainOverview/Header/NotificationDropdown/actions';

const SubscriptionStatusContainer = (props) => {

	useEffect(() => {
		return () => {
			props.actions.clearStore();
		};
	}, []);

	return <div id='subscription-status-tab-container'>
		<LoadingStatusWrapper
			loadingStatus={
				props.model.generalFilterLoadingStatuses
			}>
			<SubscriptionStatusComponent {...props} />
		</LoadingStatusWrapper>
	</div>;
};


const mapStateToProps = (state) => {
	const model = getModel(state);
	return {
		model
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		actions: bindActionCreators({ ...actions, setSelectedNotification }, dispatch)
	};
};

const subscriptionStatusContainerWithErrorBoundaryTrigger = withErrorBoundaryTrigger(SubscriptionStatusContainer);
const SubscriptionStatusContainerConn = connect(
	mapStateToProps,
	mapDispatchToProps
)(subscriptionStatusContainerWithErrorBoundaryTrigger);

export default SubscriptionStatusContainerConn;
